import { render, staticRenderFns } from "./OffcanvasSearchBox.vue?vue&type=template&id=c6547418&"
import script from "./OffcanvasSearchBox.vue?vue&type=script&lang=js&"
export * from "./OffcanvasSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports